import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TProductionSchedulingVariantDM from './TProductionSchedulingVariantDM'
import TResourceDM from './TResourceDM'

/**
 * Kalendáře variant zaplánování
 */
export default class TSchedulingVariantCalendarDM extends Data {
	public static className = 'TSchedulingVariantCalendarDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Kalendář
	 */
	CalendarId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Varianta zaplánování
	 */
	@Type(() => TProductionSchedulingVariantDM)
	SchedulingVariantId?: TProductionSchedulingVariantDM

	/**
	 * Zdroj
	 */
	@Type(() => TResourceDM)
	ResourceId?: TResourceDM
}